import logo4 from '../../assets/Logos/Test/moment.png';
import logo25 from '../../assets/Logos/Test/25 - Paramount 100th - Logo 05.png';
import logo29 from '../../assets/Logos/Test/29 - Time Intertainment - Logo.png';
import logo30 from '../../assets/Logos/Test/Alibaba - Logo2.png';
import logo31 from '../../assets/Logos/Test/Beijing Parkview - Logo.png';
import logo48 from '../../assets/Logos/Test/Biion Footwear - New Logo.png';
import logo68 from '../../assets/Logos/Test/Bite Size Entertainement - Logo.png';
import logo18 from '../../assets/Logos/Test/Bombardier Aerospace - Logo.svg';
import logo9 from '../../assets/Logos/Test/Bulgari - Logo.png';
import logo61 from '../../assets/Logos/Test/C2 - Logo.png';
import logo34 from '../../assets/Logos/Test/Canadian National Railway - Logo.png';
import logo33 from '../../assets/Logos/Test/Canadian Olympic Committee - Logo.png';
import logo19 from '../../assets/Logos/Test/CSA-2023 - Logo.png';
import logo21 from '../../assets/Logos/Test/Carnival UK - P&O Cruises - Cunard-4.png';
import logo3 from '../../assets/Logos/Test/CDS New Logo.png';
import logo37 from '../../assets/Logos/Test/Champagne Nicolas Feuillatte - Logo2.png';
import logo42 from '../../assets/Logos/Test/Club Med - Logo.png';
import logo62 from '../../assets/Logos/Test/Deloitte - Logo.png';
import logo67 from '../../assets/Logos/Test/Déferlantes - Logo2.png';
import logo15 from '../../assets/Logos/Test/Ernst & Young - Logo.png';
import logo2 from '../../assets/Logos/Test/FIFA - Logo.png';
import logo40 from '../../assets/Logos/Test/Fosun - Logo2.png';
import logo32 from '../../assets/Logos/Test/Glade2 - Logo.png';
import logo8 from '../../assets/Logos/Test/Google2 - Logo.png';
import logo43 from '../../assets/Logos/Test/Hilton Hotels and Resorts - Logo2.png';
import logo16 from '../../assets/Logos/Test/Inifinity Car - Logo2.png';
import logo52 from '../../assets/Logos/Test/Ivanoe Cambridge - Log02.png';
import logo24 from '../../assets/Logos/Test/Just for Laughs - Logo2.png';
import logo20 from '../../assets/Logos/Test/LAX-logo2.png';
import logo64 from '../../assets/Logos/Test/Loto Quebec - Logo.png';
import logo35 from '../../assets/Logos/Test/Magnum Ice Cream - Logo.png';
import logo7 from '../../assets/Logos/Test/Mastercard Logo2.png';
import logo999 from '../../assets/Logos/Test/Matane productions - Logo.png';
import logo50 from '../../assets/Logos/Test/Mexico Tourism - Logo.png';
import logo6 from '../../assets/Logos/Test/Microsoft2 - Logo.png';
import logo41 from '../../assets/Logos/Test/Monte Carlo - Societe des bains de mer - Logo2.png';
import logo5 from '../../assets/Logos/Test/Montreal Canadiens - Logo.png';
import logo62b from '../../assets/Logos/Test/Montreal en lumiere - Logo2.png';
import logo22 from '../../assets/Logos/Test/MSC Cruises - Logo2.png';
import logo1 from '../../assets/Logos/Test/NBA - Logo.png';
import logo6b from '../../assets/Logos/Test/One Drop - New Logo.png';
import logo74 from '../../assets/Logos/Test/Prince Edward Island - Logo.png';
import logo63 from '../../assets/Logos/Test/Productions-J - Logo2.png';
import logo39 from '../../assets/Logos/Test/Rexel - Logo.png';
import logo32b from '../../assets/Logos/Test/S.C. Johnson - Logo.png';
import logo10 from '../../assets/Logos/Test/Sales Force - Logo2.png';
import logo14 from '../../assets/Logos/Test/SAP - Logo2.png';
import logo66 from '../../assets/Logos/Test/Sid Lee - New Logo2.png';
import logo49 from '../../assets/Logos/Test/Situ Studio - Logo.png';
import logo17 from '../../assets/Logos/Test/Skoda Auto2 - Logo.png';
import logo13 from '../../assets/Logos/Test/Sun Life Logo2.png';
import logo11 from '../../assets/Logos/Test/T-Mobile - Logo2.png';
import logo12 from '../../assets/Logos/Test/The Dubai Mall - Logo.png';
import logo36 from '../../assets/Logos/Test/Tim Hortons - Logo3.png';
import logo38 from '../../assets/Logos/Test/TPG - Logo2.png';
import logo70 from '../../assets/Logos/Test/Trio Orange - New logo.png';
import logo45 from '../../assets/Logos/Test/World Economic Forum - Logo2.png';
// import img55 from '../../assets/Logos/Test/Zac Brown Band - New Logo2.png';

export const logosData = [
    { img: logo1, invert: true },
    { img: logo2, invert: true },
    { img: logo3, scale: '130%' },
    { img: logo4, scale: '130%' },
    { img: logo5, invert: true },
    { img: logo6, invert: true },
    { img: logo6b },
    { img: logo7, invert: true },
    { img: logo8, invert: true },
    { img: logo9 },
    { img: logo10, invert: true },
    { img: logo11, invert: true, scale: '130%' },
    { img: logo12 },
    { img: logo13, invert: true, scale: '170%' },
    { img: logo14, invert: true },
    { img: logo15 },
    { img: logo16, invert: true },
    { img: logo17, invert: true },
    { img: logo18 },
    { img: logo19, scale: '150%' },
    { img: logo20, invert: true, scale: '130%' },
    { img: logo21, invert: true, scale: '150%' },
    { img: logo22, invert: true },
    { img: logo24, scale: '130%' },
    { img: logo25, scale: '130%' },
    { img: logo29 },
    { img: logo30, invert: true },
    { img: logo31 },
    { img: logo32, invert: true },
    { img: logo32b },
    { img: logo33, scale: '130%' },
    { img: logo34 },
    { img: logo35, invert: true, scale: '130%' },
    { img: logo36, invert: true },
    { img: logo37, invert: true },
    { img: logo38, invert: true },
    { img: logo39, invert: true },
    { img: logo40, scale: '150%' },
    { img: logo41, invert: true, scale: '170%' },
    { img: logo42, scale: '180%' },
    { img: logo43, invert: true },
    { img: logo45, invert: true, scale: '170%' },
    { img: logo48 },
    { img: logo49 },
    { img: logo50 },
    { img: logo52, invert: true },
    { img: logo61 },
    { img: logo62 },
    { img: logo62b, invert: true, scale: '130%' },
    { img: logo63, invert: true },
    { img: logo64 },
    { img: logo66, invert: true },
    { img: logo67, invert: true },
    { img: logo68 },
    { img: logo70 },
    { img: logo74, scale: '150%' },
    { img: logo999, invert: true },
    // { img: img55, invert: true, scale: '150%' },
];
